<div class="request-for-quotation__table-container">
  <procure-loading-indicator [active]="isLoading()" />
  <div class="request-for-quotation__table-wrapper">
    <table
      class="request-for-quotation__table"
      aria-label="Request for Quotations"
      mat-table
      matSort
      matSortActive="entityNumber"
      matSortDirection="asc"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="entityNumber">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--entityNumber"
          mat-header-cell
          mat-sort-header="entityNumber"
        >
          RFQ
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          <procure-entity-badge
            [label]="entity.number"
            [openInNewTab]="openInNewTab"
          />
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--name"
          mat-header-cell
          mat-sort-header="name"
        >
          Name
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          @if (!openInNewTab) {
            <a
              class="text-link"
              [routerLink]="['/', entity.number]"
            >
              {{ entity.scope || entity.name }}
            </a>
          }
          @if (openInNewTab) {
            <a
              class="text-link"
              rel="noopener noreferrer"
              target="_blank"
              [routerLink]="['/', entity.number]"
            >
              {{ entity.scope || entity.name }}
            </a>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--status"
          mat-header-cell
          mat-sort-header="status"
        >
          Status
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          <procure-status-badge [status]="entity.status" />
        </td>
      </ng-container>
      <ng-container matColumnDef="currency">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--currency"
          mat-header-cell
          mat-sort-header="currency"
        >
          Currency
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.currency }}
        </td>
      </ng-container>
      <ng-container matColumnDef="country">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--country"
          mat-header-cell
          mat-sort-header="country"
        >
          Country or Territory
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.finalDestinationCountry }}
        </td>
      </ng-container>
      <ng-container matColumnDef="price">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--price"
          mat-header-cell
          mat-sort-header="price"
        >
          Price
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.totalQuotationPrice | number }}
        </td>
      </ng-container>
      <ng-container matColumnDef="incoterms">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--incoterms"
          mat-header-cell
          mat-sort-header="incoterms"
        >
          Incoterms
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.incoterms }}
        </td>
      </ng-container>
      <ng-container matColumnDef="dueDate">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--dueDate"
          mat-header-cell
          mat-sort-header="dueDate"
        >
          Due Date
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.dueDate | date }}
        </td>
      </ng-container>
      <ng-container matColumnDef="validUntil">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--validUntil"
          mat-header-cell
          mat-sort-header="validUntil"
        >
          Valid Until
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.validUntil | date }}
        </td>
      </ng-container>
      <ng-container matColumnDef="projectSCM">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--projectSCM"
          mat-header-cell
          mat-sort-header="projectSCM"
        >
          Project SCM
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.projectSCM }}
        </td>
      </ng-container>
      <ng-container matColumnDef="bu">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--bu"
          mat-header-cell
          mat-sort-header="bu"
        >
          BU
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.businessUnit }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lui">
        <th
          *matHeaderCellDef
          class="request-for-quotation__column--lui"
          mat-header-cell
          mat-sort-header="lui"
        >
          LUI
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.localUserIsland }}
        </td>
      </ng-container>
      <tr *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length">There are no Request for Quotations.</td>
      </tr>
      <tr
        *matHeaderRowDef="displayedColumns"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns"
        mat-row
      ></tr>
    </table>
  </div>
  <procure-paginator
    class="request-for-quotation__pagination"
    [length]="dataSourceTotalLength"
  />
</div>
